import { ref, type Ref } from 'vue';
import { TransactionRelationshipSelectOptions } from '@/modules/accounting/models/TransactionRelationshipSelectOptions';

export const transactionRelationshipSelectOptions: Ref<
  TransactionRelationshipSelectOptions | undefined
> = ref(undefined);
